import allCountries from './countries';
export const countries = allCountries.map((country) => {
    country.dialCode = `+${country.dialCode}`;
    return country;
});
export function getCountry(iso) {
    const iso2 = iso.toLowerCase();
    return countries.find(country => country.iso2 === iso2);
}
